import React from 'react'
import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material'
import { FS, SP } from '../theme/tokens'
import CaseTime from '../components/common/CaseTime'

/**
 * „Diese Bestellung ist mit diesem Produkt schon in Arbeit."
 *
 * 🔴 Warum das kein Fehlerkasten ist (N33, Owner-Entscheid E20)
 *
 * Der Endpunkt gibt 409, und die Fallansicht zeigte jeden 409 bis hierher als
 * roten `Alert severity="error"` mit dem Satz „erneut mit ?force=true" — einem
 * Hinweis, den über die Oberfläche niemand befolgen kann. Das ist eine Sperre
 * ohne Ausgang, und E20 sagt dazu: eine Sperre ohne Ausgang ist unfertig.
 *
 * Hier ist die Belegung deshalb eine AUSKUNFT mit zwei Wegen, nicht ein
 * Fehlschlag. Owner am 2026-09-21: *„bewusst, nicht automatisch, aber
 * flexibel."*
 *
 * ⚠️ **Kein Akzentbalken.** Kein 3px-Streifen oben oder links. Die Dringlichkeit
 * kommt aus der Reihenfolge (die Karte steht über dem Formular), dem
 * Schriftgewicht der Fallnummern und einem getönten Rahmen.
 *
 * 🔴 **Kein „verknüpfen"-Knopf.** Gemessen, warum nicht:
 * `POST /cases/<id>/link-case` ist 1:1 und bidirektional, eine Gruppe mit fünf
 * Fällen lässt sich damit nicht abbilden (und es gibt sie an prod). Es
 * überschreibt eine bestehende Verknüpfung still und lässt einen verwaisten
 * Zeiger zurück. Und es setzt einen BESTEHENDEN Fall voraus, den es zum
 * Zeitpunkt dieser Karte noch gar nicht gibt. Der Knopf wäre eine
 * undimensionierte eigene Aufgabe. Statt seiner: die Fallnummer ist ein Link.
 */
export default function BelegtePositionPanel({ treffer, onTrotzdem, onAbbrechen, laeuft }) {
  if (!treffer || treffer.length === 0) return null

  const einer = treffer.length === 1
  return (
    <Paper
      variant="outlined"
      sx={{
        p: SP.card,
        mb: SP.card,
        borderColor: 'warning.main',
        bgcolor: (t) => (t.palette.mode === 'light'
          ? 'rgba(237, 108, 2, 0.04)'
          : 'rgba(255, 167, 38, 0.06)'),
      }}
    >
      <Typography sx={{ fontWeight: 700, mb: SP.tight }}>
        {einer
          ? 'Diese Bestellung ist mit diesem Produkt schon in Arbeit'
          : `Diese Bestellung ist mit diesem Produkt schon ${treffer.length}× in Arbeit`}
      </Typography>

      <Stack spacing={SP.tight} sx={{ mb: SP.card }}>
        {treffer.map((t) => (
          <Stack key={t.id} direction="row" spacing={1} alignItems="center" flexWrap="wrap">
            <Typography
              component="a"
              href={`/rma/${t.id}`}
              target="_blank"
              rel="noreferrer"
              sx={{ fontWeight: 700, fontSize: FS.sm }}
            >
              {t.case_number}
            </Typography>
            <Chip size="small" label={t.status} sx={{ fontSize: FS.xs, height: 20 }} />
            {t.entry_channel && (
              <Chip size="small" variant="outlined" label={t.entry_channel}
                    sx={{ fontSize: FS.xs, height: 20 }} />
            )}
            {t.created_at && (
              <Typography component="span" sx={{ fontSize: FS.xs, color: 'text.secondary' }}>
                <CaseTime value={t.created_at} />
              </Typography>
            )}
          </Stack>
        ))}
      </Stack>

      <Typography sx={{ fontSize: FS.sm, color: 'text.secondary', mb: SP.card }}>
        Das ist keine Sperre. Ein zweiter Fall kann richtig sein, etwa bei einem
        zweiten Problem mit derselben Bestellung. Die Entscheidung wird am neuen
        Fall vermerkt, damit sie später nicht wie ein Versehen aussieht.
      </Typography>

      <Box>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" onClick={onAbbrechen} disabled={laeuft}>
            Abbrechen
          </Button>
          <Button variant="contained" color="warning" onClick={onTrotzdem} disabled={laeuft}>
            Trotzdem anlegen
          </Button>
        </Stack>
      </Box>
    </Paper>
  )
}
